import { render, staticRenderFns } from "./YouTubeFeed.vue?vue&type=template&id=1ec7a576&scoped=true"
import script from "./YouTubeFeed.vue?vue&type=script&lang=js"
export * from "./YouTubeFeed.vue?vue&type=script&lang=js"
import style0 from "./YouTubeFeed.vue?vue&type=style&index=0&id=1ec7a576&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec7a576",
  null
  
)

export default component.exports